/**
 * Created by alex.shmaltsuev on 2016-04-24.
 */
import PropTypes from 'prop-types';

import React from 'react';
import Style from './srListItem.scss';
import {Link} from 'react-router-dom';
import C from '../../constants/scoreBoard';
import C_R from '../../constants/routes';
import C_SR from '../../constants/SRview';
import Cx from 'classnames';
import BadgesContainer from './badgesContainer';
import ColumnsContainer from './columnsContainer';
import ToolTip from './toolTip';

/**
 *returns a react object with the full List Item type object
 */
const srListItem = function ({listItemId, listItemData, listBadgesData, listColumnsData, isPendingActionItem, intlObject}) {


    let reqLink = `${C_R.SR_VIEW}/${listItemId}`;
	let  sr_type = listItemData[C.SR_TYPE].value;
	let icon = sr_type == C_SR.SR_TYPE_INCIDENT ? <span className={Cx('iconIssue', Style.listItemIcon, 'IssueIcon')}></span> : <span className={Cx('iconIssue', Style.listItemIcon, 'iconRequest')}></span>;
    let detailsClass;
    switch (listColumnsData.length) {
        case 0:
            detailsClass = Cx(Style.zeroColumnDetails,'zeroColumnDetails');
            break;
        case 1:
            detailsClass = Cx(Style.oneColumnDetails,'oneColumnDetails');
            break;
        default:
            detailsClass = Cx(Style.defaultDetails,'defaultDetails');
            break;
    }
    return (
		<Link to={reqLink} className={Style.noDecoration}>
			<div className={Cx(Style.requestListItem, 'requestListItem')}>
				<div className={detailsClass}>
					<div className={Style.iconWrapper}>{icon}</div>
					<div className={Cx( Style.requestListItemSubject)}><strong><span id={`${listItemId}_num`}>{`${intlObject['ssp.idPrefix']}${listItemId}:`}</span></strong> <span id={`${listItemId}_title`}>{listItemData[C.TITLE].valueCaption}</span></div>
					<BadgesContainer
						listItemId={listItemId}
						listBadgesData={listBadgesData}
					/>
				</div>
                <ColumnsContainer
					listColumnsData={listColumnsData}
					isPendingActionItem={isPendingActionItem}
				/>
				<ToolTip
					listBadgesData={listBadgesData}
					listColumnsData={listColumnsData}
				/>
				<div className='clearfix'></div>
			</div>
		</Link>
	);
};

srListItem.propTypes = {
    listItemId: PropTypes.string.isRequired,
    listItemData: PropTypes.object.isRequired,
    listBadgesData: PropTypes.array.isRequired,
    listColumnsData: PropTypes.array.isRequired,
    isPendingActionItem:PropTypes.bool.isRequired,
    intlObject:PropTypes.object.isRequired
};

export default srListItem;



// WEBPACK FOOTER //
// ./components/Scoreboard/srListItem.js